import { createAction } from "@reduxjs/toolkit";
import {
  createProposalActionTypes,
  getMoreProposalUsersActionTypes,
  getProposalUsersActionTypes,
  setProposalUsersActionType,
  addPendingProposalTypes,
  removePendingProposalTypes,
  editProposalActionTypes,
  getProposalDetailsActionTypes,
  clearIsJustCreatedActionTypes,
} from "./actionTypes";

export const getProposalUsers = createAction(
  getProposalUsersActionTypes.request,
);
export const getProposalUsersSuccess = createAction(
  getProposalUsersActionTypes.success,
);
export const getProposalUsersFailure = createAction(
  getProposalUsersActionTypes.failure,
);

export const getMoreProposalUsers = createAction(
  getMoreProposalUsersActionTypes.request,
);
export const getMoreProposalUsersSuccess = createAction(
  getMoreProposalUsersActionTypes.success,
);
export const getMoreProposalUsersFailure = createAction(
  getMoreProposalUsersActionTypes.failure,
);

export const setProposalUsers = createAction(setProposalUsersActionType);

export const createProposal = createAction(createProposalActionTypes.request);
export const createProposalSuccess = createAction(
  createProposalActionTypes.success,
);
export const createProposalFailure = createAction(
  createProposalActionTypes.failure,
);

export const createProposalReset = createAction(
  createProposalActionTypes.reset,
  (payload) => ({ payload }),
);

export const addPendingProposal = createAction(
  addPendingProposalTypes.request,
  (payload) => ({ payload }),
);

export const removePendingProposal = createAction(
  removePendingProposalTypes.request,
  (payload) => ({ payload }),
);

export const editProposal = createAction(editProposalActionTypes.request);
export const editProposalSuccess = createAction(
  editProposalActionTypes.success,
);
export const editProposalFailure = createAction(
  editProposalActionTypes.failure,
);
export const editProposalReset = createAction(editProposalActionTypes.reset);

export const getProposalDetails = createAction(
  getProposalDetailsActionTypes.request,
);
export const getProposalDetailsSuccess = createAction(
  getProposalDetailsActionTypes.success,
);
export const getProposalDetailsFailure = createAction(
  getProposalDetailsActionTypes.failure,
);

export const clearIsJustCreated = createAction(
  clearIsJustCreatedActionTypes.request,
);
